import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@bo-client/config/config.service';
import { GisDataModel } from '@bo-client/shared/models/gisData';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

import { catchError, map } from 'rxjs/operators';
import { AutocompleteStrategy } from '@bo-client/shared/components/get-gis-data/autocomplete.strategy';
import { MapAreasSWPEnum } from '@bo-client/activation-management/shared/components/select-gis-data/select-gis-data.model';

@Injectable({
  providedIn: 'root'
})
export class SWPAutocompleteStrategy implements AutocompleteStrategy {
  constructor(public httpClientBack: HttpClient, public configService: ConfigService) {}

  getCitySuggestions(val: string): Observable<GisDataModel[]> {
    return this.httpApiSWP('Cities?plz_city_lookup=' + val.toString() + '&limit=20').pipe(
      map((x) => this.listCityToShow(x))
    );
  }

  getStreetSuggestions(selectedGisData: GisDataModel, val: string): Observable<GisDataModel[]> {
    return this.httpApiSWP(
      'Streets?street_lookup=' + val.toString() + '&city_id=' + selectedGisData.cityId + '&limit=20'
    ).pipe(map((x) => this.listStreetToShow(x)));
  }

  getStreetNoSuggestions(selectedGisData: GisDataModel, val: string): Observable<GisDataModel[]> {
    return this.httpApiSWP(
      'HouseNo?houseNo_lookup=' + val.toString() + '&street_id=' + selectedGisData.streetId + '&limit=20'
    ).pipe(
      catchError((err, caught) => {
        return [];
      }),
      map((x) => this.listStreetNoToShow(x))
    );
  }

  listCityToShow(apiRes: any): GisDataModel[] {
    return apiRes;
  }

  listStreetToShow(apiRes: any): GisDataModel[] {
    return apiRes;
  }

  listStreetNoToShow(apiRes: any): GisDataModel[] {
    return apiRes.map((ele) => {
      const gridConnectionPoints = MapAreasSWPEnum.map((areaEnum) => ({
        area: areaEnum.area,
        value: ele.sapInfo[areaEnum.code] || 'N/A' // Falls kein Wert vorhanden ist, setzen Sie einen Standardwert wie 'N/A'
      }));

      return {
        id: ele.id,
        houseNo: ele.houseNo,
        houseNoAddition: ele.houseNoAddition,
        // todo vorübergehende Lösung weil areas list leer war
        availableAreas: ele.areasGeneral && ele.areasGeneral.length > 0 ? ele.areasGeneral : ele.areasExists,
        gridConnectionPoints: gridConnectionPoints
      };
    });
  }

  isAvailableArea(areaType: AreaTypeEnum, selectedOption: GisDataModel): boolean {
    let isAvailable = false;
    if (selectedOption.availableAreas) {
      const idxSWPEnum = MapAreasSWPEnum.findIndex((ele) => ele.area.toLowerCase() == areaType.toLowerCase());
      if (idxSWPEnum != -1) {
        const idxCode = selectedOption.availableAreas.findIndex(
          (ele) => ele.toLowerCase() == MapAreasSWPEnum[idxSWPEnum].code.toLowerCase()
        );
        if (idxCode != -1) {
          isAvailable = true;
        }
      }
    }
    return isAvailable;
  }

  private httpApiSWP(apiUri: string): Observable<any> {
    return this.httpClientBack.get<any>(`${this.configService.getSettings('gisURLSWP')}${apiUri}`);
  }
}
